<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="领用单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>领用单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="出库仓库" v-if="getIsView()">
                <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getWarehousesBySessionWarehouseId" @change="warehouseChange" style="width:100%">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>出库仓库:{{ form.warehouseName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="outStockDeptName" label="出库科室" v-if="getIsView()">
                <el-select v-if="system_setting.IsUseWard" v-model="form.outStockDeptName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptAndWards1" @change="outStockDeptChange1">
                  <el-option v-for="item in STATIC_DeptAndWards1" :key="item.idGroup" :label="item.deptNo+' '+item.deptName +' '+(item.wardName?item.wardName:'')" :value="item.idGroup"></el-option>
                </el-select>

                <el-select v-else v-model="form.outStockDeptName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getDepts" @change="outStockDeptChange" style="width:100%">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>出库科室:{{ form.outStockDeptName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="date" label="出库日期" v-if="getIsView()">
                <el-date-picker :disabled="!editMode" v-model="form.date" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="入库日期" style="width:100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>出库日期:{{  parseTime(new Date(form.date), "{y}-{m}-{d}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="category" label="出库类型" v-if="getIsView()">
                <el-radio-group :disabled="!editMode" v-model="form.category">
                  <el-radio v-for="item in StockCategoryOptions" :key="item.id" :label="item.id">{{item.name + '出库'}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <span class="viewText" v-else>出库类型:{{ StockCategoryOptions.find(item => item.id == form.category)?.name+'出库' }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总数量:{{ form.totalNumber }} </span>
            </el-col>
          <!-- </el-row>

          <el-row> -->
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientNo" label="住院号" v-if="getIsView()">
                <el-input disabled v-model="form.patientNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>住院号:{{ form.patientNo }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientName" label="患者姓名" v-if="getIsView()">
                <el-input disabled v-model="form.patientName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>患者姓名:{{ form.patientName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorName" label="医生姓名" v-if="getIsView()">
                <el-input disabled v-model="form.doctorName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>医生姓名:{{ form.doctorName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorNo" label="医生工号" v-if="getIsView()">
                <el-input disabled v-model="form.doctorNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>医生工号:{{ form.doctorNo }} </span>
            </el-col>
          <!-- </el-row>
          <el-row> -->
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="成本科室" prop="chargeDeptId" v-if="getIsView()">

                <el-select v-if="system_setting.IsUseWard" v-model="form.chargeDeptName" placeholder="请选择" :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptAndWards1" @change="chargeDeptChange1">
                  <el-option v-for="item in STATIC_DeptAndWards1" :key="item.idGroup" :label="item.deptNo+' '+item.deptName +' '+(item.wardName?item.wardName:'')" :value="item.idGroup"></el-option>
                </el-select>
                <!--12  -->
                <el-select v-else v-model="form.chargeDeptName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getDepts" @change="chargeDeptChange" style="width:100%">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
                <!-- <el-input :disabled="!editMode" placeholder="成本科室" v-model="form.chargeDeptName"></el-input> -->
              </el-form-item>
              <span class="viewText" v-else>成本科室:{{ form.chargeDeptName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="总金额(计费价)" v-if="getIsView()">
                <el-input disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总金额(计费价):{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalPurchaseAmount" label="总金额(采购价)" v-if="getIsView()">
                <el-input disabled placeholder="请输入总金额" v-model="form.totalPurchaseAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总金额(采购价):{{ form.totalPurchaseAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>

          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">出库明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" type="danger" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
            <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button>
            <el-input :disabled="!editMode" placeholder="在此处扫描标签码添加明细" v-model="rfid" ref="rfidInput" style="width:300px;margin:0 20px" @input="rfidChange"></el-input>
            <!-- <el-input :disabled="!editMode" placeholder="扫描标签码添加明细" v-model="tagCode" ref="tagCodeInput" style="width:300px;margin-left:30px" @change="tagCodeChange"></el-input> -->
            <el-button class="btn primary" type="primary" style="margin-right: 10px"
            @click="showTransfer">自定义设置</el-button>
          </div>
          
          <div v-else style="margin: 20px 0 12px 10px">
            <el-button class="btn primary" type="primary" style="margin-right: 10px"
            @click="showTransfer">自定义设置</el-button>
          </div>


          <div v-if="tableHaeder.length>0">
            <CustomTable  ref="customTable" :tableData="form.details" @handleSelectionChange="handleChildSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
            :tableHeight="tableHeight"  :tableCode="route.name" :cellDblclick="cellDblclick"> 
              <template slot="before">
                <el-table-column type="index" width="50" fixed> </el-table-column>
                <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
              </template>
              <template slot="after">
                <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" prop="operation" v-if="this.system_setting.costAccountingType == 1" label="移库单详细" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" v-preventReClick @click="handleMoveLiBrayInfo(scope.row)" class="color-blue">查看详情</el-button>
                  </template>
                </el-table-column>
              </template>
            </CustomTable>
          </div>
          <div v-else>
            <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
              <el-table-column type="index" width="50" fixed> </el-table-column>
              <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
       
              <el-table-column show-overflow-tooltip prop="productName" label="产品" width="180" fixed></el-table-column>
              <el-table-column show-overflow-tooltip prop="specName" label="产品规格" width="130" fixed></el-table-column>
              <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
          
              <!-- <el-table-column prop="brand" label="品牌" width="120"></el-table-column> -->
              <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="130"></el-table-column>
              <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证" width="180"></el-table-column>
              <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="130"></el-table-column>
              <el-table-column prop="number" label="数量" width="120"></el-table-column>
              <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
              <el-table-column prop="unit" label="包装单位" width="80"></el-table-column>
              <el-table-column prop="price" label="计费价" width="120"></el-table-column>
              <el-table-column prop="purchasePrice" label="采购价" width="120"></el-table-column>
              <el-table-column prop="amount" label="小计(计费价)" width="120"></el-table-column>
              <el-table-column prop="purchaseAmount" label="小计(采购价)" width="120"></el-table-column>
              <el-table-column prop="patientIdArr" label="患者" width="180">
                <template slot-scope="scope">
                  <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
                    <div slot="content" class="">
                      <div class="tooltip-text" v-for="item in scope.row.patientInfos" :key="item.id">
                        {{ item.no + ' ' + item.name}}
                      </div>
                    </div>
                    <span class="td-overflow-hidden">{{
                      scope.row.patientInfos
                        ? scope.row.patientInfos.map((e) => e.no + ' ' + e.name).join(";")
                        : ""
                    }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="packSpec" label="包装规格" width="120">
              </el-table-column>
              <el-table-column prop="locationName" label="货位" width="180"></el-table-column>
              <el-table-column prop="batch" label="批次号" width="120"></el-table-column>
              <el-table-column prop="validityDate" label="有效期" width="150">
                <template slot-scope="scope">
                  {{ scope.row.validityDate? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") : ""}}
                </template>
              </el-table-column>
              <el-table-column prop="longTime" label="长期" width="60">
                <template slot-scope="scope">
                  {{ scope.row.longTime == 1 ? "是" : "否"}}
                </template>
              </el-table-column>
              <el-table-column prop="manufactureDate" label="生产日期" width="150">
                <template slot-scope="scope">
                  {{scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : ""}}
                </template>
              </el-table-column>
              <el-table-column prop="serialNo" label="序列号" width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="mainNo" label="主条码" width="180"></el-table-column>
              <el-table-column show-overflow-tooltip prop="traceNo" label="追溯码" width="180"></el-table-column>
              <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号" width="180"></el-table-column>
              <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
              <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
              
              <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
                </template>
              </el-table-column>
              <el-table-column fixed="right" prop="operation" v-if="this.system_setting.costAccountingType == 1" label="移库单详细" width="150">
                <template slot-scope="scope">
                  <el-button type="text" v-preventReClick @click="handleMoveLiBrayInfo(scope.row)" class="color-blue">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row v-if="isScan">
            <el-col :span="24">
              <el-form-item label="扫码框">
                <el-input placeholder="请扫码" ref="no" @change="mainNoChange" v-model="childForm.no" @focus="scanInputFocus" @blur="scanInputBlur"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="mainNo" label="主条码">
                <el-input disabled placeholder="请输入主条码" v-model="childForm.mainNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="traceNo" label="追溯码">
                <el-input disabled placeholder="请输入追溯码" v-model="childForm.traceNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="supplierProductNo" label="供应商产品编码">
                <el-input disabled v-model="childForm.supplierProductNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="productBox">
               <el-checkbox class="noCharge" v-model="billingLogo" @change="billingLogoChange">仅选不计费库存</el-checkbox>
              <el-form-item prop="productName" label="产品名称">
                <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>

                <SelectTable v-if="!isScan" :disabled="!editMode" :columns="stockColumns" :innerName="childForm.productName" :dataList="STATIC_Stocks" @filterMethod="getProductList" @change="productChange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="childForm.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertId" label="产品注册证">
                <el-input disabled v-model="childForm.productRegistCertName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="supplierName" label="供应商">
                <el-input disabled v-model="childForm.supplierName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="childForm.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="onlineNo" label="挂网号">
                <el-input disabled v-model="childForm.onlineNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="brand" label="品牌">
                <el-input disabled v-model="childForm.brand"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="packSpec" label="患者">
                <el-select v-model="childForm.patientIdArr" :reserve-keyword="true" filterable clearable multiple :disabled="!editMode" placeholder="请选择" :filter-method="getPatientList" @change="patientChange" style="width:100%">
                  <el-option v-for="(item, index) in patientList" :key="index" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="packSpec" label="包装规格">
                <el-input :disabled="!editMode" v-model="childForm.packSpec"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="minUnit" label="最小单位">
                <el-input disabled v-model="childForm.minUnit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="unit" label="包装单位">
                <el-input disabled v-model="childForm.unit"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item prop="disinfectDate" label="灭菌日期">
                <el-date-picker :disabled="!editMode" v-model="childForm.disinfectDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="disinfectBatch" label="灭菌批号">
                <el-input :disabled="!editMode" placeholder="请输入灭菌批号" v-model="childForm.disinfectBatch"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item prop="manufactureDate" label="生产日期">
                <el-date-picker disabled v-model="childForm.manufactureDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择生产日期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="validityDate" label="有效期">
                <el-date-picker disabled v-model="childForm.validityDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择有效期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item prop="longTime" label="长期">
                <el-switch v-model="childForm.longTime" disabled active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="batch" label="批次号">
                <el-input disabled placeholder="请输入批次号" v-model="childForm.batch"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="serialNo" label="序列号">
                <el-input disabled placeholder="请输入序列号" v-model="childForm.serialNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="locationName" label="货位">
                <el-input disabled v-model="childForm.locationName"></el-input>
                <!-- <el-select :disabled="!editMode" placeholder="请选择货位" v-model="childForm.locationName" filterable @change="childLocationChange" style="width:100%">
                  <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="number" label="数量">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="price" label="计费价">
                <el-input disabled @input="autoAmount" v-model="childForm.price"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="purchasePrice" label="采购价">
                <el-input disabled @input="autoAmount" v-model="childForm.purchasePrice"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="amount" label="小计(计费价)">
                <el-input disabled v-model="childForm.amount"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="purchaseAmount" label="小计(采购价)">
                <el-input disabled v-model="childForm.purchaseAmount"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item prop="newProductId" label="产品ID">
                <el-input disabled v-model="childForm.newProductId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productCode" label="商品代码">
                <el-input disabled v-model="childForm.productCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="newOnlineNo" label="新挂网号">
                <el-input disabled v-model="childForm.newOnlineNo"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode&&$route.query.inStockId" class="btn default" v-preventReClick @click="goBack">返回科室入库</el-button>
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button  v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    <MoveLibrayTable ref="selectDialog" :show="showSelectDialog" :dialogTitle="selectDialogTitle" @close="closeSelectDialog" :tipColumOptions="tipColumOptions" :columOptions="columnOptions" :dataList="movelibrayList">查看</MoveLibrayTable>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
     <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import OutStockScan from '@/mixin/outStockScan-mixin'
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  SpdGetDeptInStockById,
  RejectCollectOutStock,
  GetCollectOutStockById,
  SaveCollectOutStock,
  GetPatientDetails,
  GetMoveLibraryByDetailId,
  GetPackViewModels,
  SaveCollectOutStockTemp
} from "@/api";
import { StockCategoryOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import MoveLibrayTable from "@/components/move-libray-table";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
import { Debounce } from '@/utils/utils'

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, OutStockScan,tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    MoveLibrayTable,
    LabelDetailsDialog,
    PackageLabelDialog,
  },
  data () {
    return {
      GetDataAction: GetCollectOutStockById,
      SaveDataAction: SaveCollectOutStock,
      reject: RejectCollectOutStock,
      SaveTempAction: SaveCollectOutStockTemp,
      form: {},
      StockCategoryOptions: StockCategoryOptions,
      rules: {
        warehouseName: [
          { required: true, message: '请选择出库仓库', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择出库日期', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择出库类型', trigger: 'blur' }
        ],
        // supplierName: [{ required: true, message: '请选择供应商', trigger: 'blur' }]
        chargeDeptId: [{ required: true, message: '请选择成本科室', trigger: 'blur' }]
      },
      childFormRules: {
        productName: [{ required: true, message: "请选择产品", trigger: "blur" }],
        // manufactureDate: [{ required: true, message: "请选择生产日期", trigger: "blur" }],
        // validityDate: [{ required: true, message: "请选择有效期", trigger: "blur" }],
        // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        // productRegistCertId: [{ required: true, message: "请选择产品注册证", trigger: "blur" }],
        // packSpec: [{ required: true, message: "请输入包装规格", trigger: "blur" }],
        // manufactureDate: [
        //   { required: true, message: "请选择生产日期", trigger: "blur" },
        //   { validator: this.validateManufacturerDate, trigger: 'blur' },
        //   { validator: this.validateDateRange, trigger: 'blur' }
        // ],
        // validityDate: [
        //   { required: true, message: "请选择有效期", trigger: "blur" },
        //   { validator: this.validateValidityDate, trigger: 'blur' },
        //   { validator: this.validateDateRange, trigger: 'blur' }
        // ],
        price: [
          { required: true, message: "请输入计费价", trigger: "blur" },
        ],
        number: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      selectDialogTitle: '移库详情',
      showSelectDialog: false,
      isScan: false,
      patientList: [],
      movelibrayList: [],
      tipColumOptions: [],
      columnOptions: [
        {
          label: "移库单号",
          key: "no",
          width: 140
        },
        {
          label: "仓库",
          key: "warehouseName",
          width: 100
        },
        {
          label: "领用科室",
          key: "applyDeptName",
          width: 80
        },
        {
          label: '领用人',
          key: 'applyUserName',
          width: 70
        },
        {
          label: '住院号',
          key: 'patientNo',
          width: 80
        },
        {
          label: "患者姓名",
          key: "patientName",
          width: 80
        },
        {
          label: "医生工号",
          key: "doctorUserName",
          width: 80
        },
        {
          label: "医生姓名",
          key: "doctorUserNo",
          width: 80
        },
        {
          label: "数量",
          key: "totalNumber",
          width: 60
        },
        {
          label: "金额",
          key: "totalAmount",
          width: 60
        },
        {
          label: "备注",
          key: "remark",
        },
      ],
      rfid: '',
      billingLogo: true,
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    }else if(query.inStockId){
      this.getSpdGetDeptInStockById(query.inStockId)
    } else {
      this.handleAdd();
    }

    this.getPatientList('')
    this.getWarehousesBySessionWarehouseId('')
    // this.getSuppliers('');


    if (this.system_setting.IsUseWard) {
      this.getDeptAndWards1()

    } else {
      this.getDepts('')
    }

    this.getTabelList("");
   
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;

      this.getProductList('')
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        // this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

        this.getProductList('')
      });
    },
    // 保存
    submit () {
      this.$store.dispatch('SetLoading',true)
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading',false)
          return false;
        }
        
        var valdateResult = this.productDetailRepeatValidate(this.form.details)
        if (!valdateResult.flag) {
          this.$my_message(valdateResult.msg, 'warning')
          this.$store.dispatch('SetLoading',false)
          return;
        }

        //校验产品是否已过期
        var productPeriodValidate = this.checkProductOverdueValidate(this.form.details);
        if (!productPeriodValidate.flag) {
          const h = this.$createElement;
          let content = [];
          content.push(
            h(
              "p", `${productPeriodValidate.msg}`,
            )
          );
          content.push(
            h(
              "p", `是否继续？`,
            )
          );
          this.$confirm("提示", {
            title: "提示",
            type: "warning",
            customClass: "promptBox",
            showCancelButton: true,
            showConfirmButton: true,
            message: h("div", content),
          }).then(() => {
            this.Save();
          }).catch((e) => {
            throw new Error(productPeriodValidate.msg);
          });
        } else {
          this.Save();
        }
      });
    },
    Save () {
      // this.loading = true
      this.SaveDataAction(this.form).then((res) => {
        this.$my_message(`执行成功`, "success");
        sessionStorage.setItem("editMode", 0);
        // this.$router.push({ path: this.getMainPath(this.$route.path) });
        this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
      }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });
    },
    resetForm () {
      this.form = {
        supplierId: "",
        deliveryTime: new Date(),
        // warehouseCategory: "1",
        "warehouseId": '',// this.userInfo.defaultWarehouseId,
        warehouseName: '',// this.userInfo.defaultWarehouseName,
        warehouseManagerId: '',// this.userInfo.defaultWarehouseManagerId,
        warehouseManagerName: '',// this.userInfo.defaultWarehouseManagerName,
        totalNumber: 0,
        totalAmount: 0,
        totalPurchaseAmount: 0,
        orderNo: "",
        category: 0,
        remark: "",
        "balanceStatus": 2,
        chargeDeptName:  this.system_setting.IsUseWard?`${this.mySessionStorage.getDeptName()} ${this.mySessionStorage.getWardName()} `:this.mySessionStorage.getDeptName(),
        chargeDeptId:  this.mySessionStorage.getDeptId(),
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        chargeWardId:this.system_setting.IsUseWard?this.mySessionStorage.getWardId():'',
        outStockDeptName:this.system_setting.IsUseWard?`${this.mySessionStorage.getDeptName()} ${this.mySessionStorage.getWardName()} `:this.mySessionStorage.getDeptName(),
        outStockDeptId : this.mySessionStorage.getDeptId(),
        outStockWardId:this.system_setting.IsUseWard?this.mySessionStorage.getWardId():'',
        orgCode :sessionStorage.getItem('orgId'),
      };
      
      this.setDefaultWarehouseBySessionWarehouseId(2)
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },
    closeSelectDialog () {
      this.showSelectDialog = false
    },
    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
    handleDeleteChildForm () {
      if(this.checkIsRfid(this.childMultipleSelection)){
        this.$my_message(`存在打包类标签明细，不能删除！`, "warning");
        return
      }
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      this.$set(
        this.childForm,
        "patientIdArr",
        this.childForm.patientInfos.map((e) => e.id)
      );
      // this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        "locationName": "",
        "mainNo": "",
        "traceNo": "",
        supplierProductId: '',
        "productId": '',
        "specId": '',
        productRegistCertId: '',
        "productRegistCertNo": "",
        "onlineNo": "",
        "unit": "",
        "minUnit": "",
        "packSpec": "",
        "manufacturerId": '',
        "locationId": '',
        "manufactureDate": "",
        "batch": "",
        "validityDate": "",
        "serialNo": "",
        "number": 1,
        unChargeNumber: 1,
        "price": 0,
        "amount": 0,
        purchaseAmount: 0,
        "remark": "",
        patientIdArr: [],
        patientInfos: [],
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      
      let arr = this.STATIC_Stocks.filter(item=>item.supplierProductNo == this.childForm.supplierProductNo)
       let show = false
      const validDates = arr
        .map(item => item.validityDate ? new Date(item.validityDate) : null)
        .filter(date => date && !isNaN(date.getTime()));

      const childValidityDate = this.childForm.validityDate;
      const isChildDateEmpty = !childValidityDate || childValidityDate.trim() === '';

      if (isChildDateEmpty) {
        if (validDates.length > 0) {
         show = true
        }
      } else {
        // 情况2：选中的效期不为空，检查是否为最小日期
        const childDate = new Date(childValidityDate);
        if (isNaN(childDate.getTime())) {
         show = true
        }

        if (validDates.length > 0) {
          const minDate = new Date(Math.min(...validDates));
          if (childDate.getTime() !== minDate.getTime()) {
           show = true
          }
        }
      }
      if(show){
        this.$confirm('该产品存在有效期更近的批次，是否继续', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.pushChildForm(true);
        }).catch(() => {
          
        });
      }else{
        this.pushChildForm(true);
      }
    },
    continueAdd () {
    let arr = this.STATIC_Stocks.filter(item=>item.supplierProductNo == this.childForm.supplierProductNo)
       let show = false
      const validDates = arr
        .map(item => item.validityDate ? new Date(item.validityDate) : null)
        .filter(date => date && !isNaN(date.getTime()));

      const childValidityDate = this.childForm.validityDate;
      const isChildDateEmpty = !childValidityDate || childValidityDate.trim() === '';

      if (isChildDateEmpty) {
        if (validDates.length > 0) {
         show = true
        }
      } else {
        // 情况2：选中的效期不为空，检查是否为最小日期
        const childDate = new Date(childValidityDate);
        if (isNaN(childDate.getTime())) {
         show = true
        }

        if (validDates.length > 0) {
          const minDate = new Date(Math.min(...validDates));
          if (childDate.getTime() !== minDate.getTime()) {
           show = true
          }
        }
      }
      if(show){
        this.$confirm('该产品存在有效期更近的批次，是否继续', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.editChildren = false;
      this.pushChildForm();
        }).catch(() => {
          
        });
      }else{
        this.editChildren = false;
      this.pushChildForm();
      }
      
      
    },
    handleMoveLiBrayInfo (row) {
      this.showSelectDialog = true;
      this.tipColumOptions = []
      this.tipColumOptions.push({
        name: "产品名称",
        code: 'productName',
        value: row.productName
      })
      this.tipColumOptions.push({
        name: "规格型号",
        code: 'specName',
        value: row.specName
      })
      this.tipColumOptions.push({
        name: "生产厂家",
        code: 'manufacturerName',
        value: row.manufacturerName
      })
      this.tipColumOptions.push({
        name: "批次号",
        type: 'select',
        code: 'batch',
        value: row.batch
      })
      this.tipColumOptions.push({
        name: "数量",
        code: 'number',
        value: row.number
      })
      this.tipColumOptions.push({
        name: "已移库数量",
        code: 'shareNumber',
        value: row.shareNumber
      })
      GetMoveLibraryByDetailId({ id: row.id, type: 2 })
        .then(res => {
          this.movelibrayList = res.returnData
        })
    },
    pushChildForm (close) {
      let result = true
      //  08-15 产品说不需要这个判断
      // if (this.childForm.billingLogo==0) {
      //   this.$my_message(`无法获取计费价，请先维护计费标识`, "warning");
      //   return
      // }
      this.$refs["childForm"].validate((valid) => {
        result = valid
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        if (this.childForm.mainNo && this.childForm.traceNo) {
          var childForm = this.childForm
          // 添加行
          let arr = this.form.details.filter(
            (item) => item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
          );

          // 添加行记录
          if (arr.length > 0) {
            // 存在则把列表的数据拿过来，并且数量加1
            this.form.details = this.form.details.map((item) => {
              if (
                item.mainNo == childForm.mainNo &&
                item.traceNo == childForm.traceNo
              ) {
                item.packSpec = childForm.packSpec;
                item.locationId = childForm.locationId;
                item.locationName = childForm.locationName;
                item.manufactureDate = childForm.manufactureDate;
                item.batch = childForm.batch;
                item.validityDate = childForm.validityDate;
                item.serialNo = childForm.serialNo;
                item.remark = childForm.remark;
                item.number = childForm.number;
                // item.unUseNumber = childForm.unUseNumber
                item.price = childForm.price;
                item.purchasePrice = childForm.purchasePrice;
                item.amount = childForm.amount;
                item.purchaseAmount = childForm.purchaseAmount;
              }
              return item;
            });
          } else {
            // 不存在则添加行记录
            var childForm = JSON.parse(JSON.stringify(this.childForm))
            childForm.$index = this.form.details.length + 1
            this.form.details.push(childForm)
          }
        }
        else {
          if (this.editChildren) {
            let item = this.form.details.find(
              (e) => e.$index == this.childForm.$index
            );
            Object.assign(item, this.childForm);
          }
          else {
            this.form.details.push(this.childForm)
          }
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
          this.count = 0;
          this.isScan = false;
        }
      });
      return result
    },
    childNumberChange () {
      this.childForm.unChargeNumber = this.childForm.number
      this.autoAmount();
    },
    autoAmount () {
      // this.childForm.billingPrice = this.childForm.price
      this.childForm.amount = (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      this.childForm.purchaseAmount = (this.childForm.number * this.childForm.purchasePrice).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      let totalPurchaseAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
        totalPurchaseAmount = totalPurchaseAmount * 1 + element.purchaseAmount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.totalPurchaseAmount = totalPurchaseAmount.toFixed(4) * 1;
    },


    openScanner (ev) {
      this.count = 0;
      this.resetDetailFormData();
      this.isScan = true;
      this.openSubformModal = true;

      ev.target.blur();
    },

    // change event
    patientChange () {
      this.childForm.patientInfos = this.patientList.filter(e => this.childForm.patientIdArr.indexOf(e.id) != -1)
      this.childForm.patientIds = this.childForm.patientIdArr.join(';')
    },
    warehouseChange (val) {
      this.form.warehouseId = val
      let arr = this.STATIC_Warehouses.filter(item => item.id == val)
      
      this.form.warehouseName = arr[0].name
      this.form.warehouseCategoryName = arr[0].category == 1 ? '一级库房' : '二级库房'
      this.form.warehouseCategory = arr[0].category
      let dept =  arr[0].deptInfos[0]
      this.form.outStockDeptId = dept.id
      this.form.outStockDeptName = dept.name
      this.form.outStockWardId = dept.wardIds?.split(';')[0]      
      this.form.chargeDeptId = dept.id
      this.form.chargeDeptName = dept.name
      this.form.chargeWardId = dept.wardIds?.split(';')[0]
      // this.getLocations(val)
      
      this.getProductList('')
    },
    productChange (row) {
      let id = this.childForm.id
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      this.childForm = Object.assign(this.childForm, row)// this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      this.childForm.id = id
      // this.childForm.supplierProductId = row.id
      this.childForm.number = 1
      let price = this.childForm.price
      //计费价
      this.childForm.price = row.billingLogoName == '是' ? this.childForm.price : row.billingLogoName == '' ? '' : '0'
      //采购价
      this.childForm.purchasePrice = price
      this.childForm.amount = this.childForm.price
      this.childForm.purchaseAmount = this.childForm.purchasePrice
      this.childForm.remark = ''

      this.$refs.number.focus();
      this.$refs.number.select();

      this.$refs.childForm.validateField('productName')
    },
    chargeDeptChange (val) {
      this.form.chargeDeptId = val
    },
    outStockDeptChange (val) {
      this.form.outStockDeptId = val
    },
    outStockDeptChange1 (val) {
      let arr = this.STATIC_DeptAndWards1.filter(res=>res.idGroup == val)
      this.form.outStockDeptName=  arr[0].deptName + " " + (arr[0].wardName?arr[0].wardName:'');
      this.form.outStockDeptId = arr[0].deptId
      this.form.outStockWardId = arr[0].wardId
      this.$forceUpdate()
    },
    chargeDeptChange1 (val) {
      let arr = this.STATIC_DeptAndWards1.filter(res=>res.idGroup == val)
      this.form.chargeDeptName=  arr[0].deptName + " " + (arr[0].wardName?arr[0].wardName:'');
      this.form.chargeDeptId = arr[0].deptId
      this.form.chargeWardId = arr[0].wardId
    },

   

    getSpdGetDeptInStockById(val){

      SpdGetDeptInStockById({id:val}).then(res=>{
        this.resetForm()
         this.editMode = true;
         this.form.category = res.returnData.category
         this.form.warehouseName = res.returnData.warehouseName
         this.form.warehouseId = res.returnData.warehouseId
         this.form.date = res.returnData.date
         this.form.chargeDeptName = res.returnData.inStockDeptName
         this.form.chargeDeptId = res.returnData.inStockDeptId
         this.form.chargeWardId = res.returnData.inStockWardId
         this.form.outStockDeptId = res.returnData.inStockDeptId
          this.form.outStockDeptName = res.returnData.inStockDeptName
          this.form.outStockWardId = res.returnData.inStockWardId
          let data = []
          if(this.$route.query.isProductType==1){
            data = res.returnData.details.filter(item=>item.billingLogo == 1)
          }else if(this.$route.query.isProductType == 0){
            data = res.returnData.details.filter(item=>item.billingLogo == 0)
          }else{
            data = res.returnData.details
          }
          
         this.form.details =  data.map(val=>{
          val.purchasePrice = val.price
          val.purchaseAmount = val.amount
          val.unChargeNumber = val.number
          return val
         })
         this.$nextTick(()=>{
          this.autoTotalAmount()
         })
      })

    },
    getProductList (keyWord) {
      let query = {
        userId: this.userInfo.id,
        pageIndex: 1,
        pageSize: 50,
        keyWord: keyWord,
        category: this.form.category,
        warehouseId: this.form.warehouseId,
        billingLogoType:this.billingLogo?0:1,
        modelCodeType:1,
      }
      this.getStocks(query)
    },
    getPatientList (keyWord) {
      GetPatientDetails({ keyWord: keyWord, pageSize: 100, pageIndex: 1 })
        .then(res => {
          this.patientList = res.returnData.data
        })
    },

    rfidChange:Debounce(function (val) {
      if (!val) {
        return;
      }
      const trimmedVal = val.trim();
      if (!trimmedVal.startsWith('B')) {
        this.tagCodeChange(val);
        return;
      }   
      var details = this.form.details.filter(e => e.rfid == val)
      if (details && details.length > 0) {
        return;
      }
      let query = {
        "pageSize": 50,
        "pageIndex": 1,
        rfid: val,
        warehouseId: this.form.warehouseId,
        stockCategory: 0,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId()
      }
      GetPackViewModels(query)//({ pageIndex: 1, pageSize: 50, rfid: val, deptId: this.form.deptId, stockCategory: 0 })
        .then(res => {
          if (res.successful) {
            if (!res.returnData.data || res.returnData.data.length == 0) {
              this.rfid = ''
              this.$my_message("未检索到此标签码", 'warning');
              this.$store.dispatch('SetLoading',false)
              return
            }
            res.returnData.data.map(item => {
              item.purchasePrice = item.billingPrice
              item.purchaseAmount = item.price
              item.rfid = item.no
              this.form.details.push(item)
            })

            this.getSpanArr(this.form.details)
            this.rfid = ''
            this.autoTotalAmount()
          }
        })
    },500),
   

    goBack () {
      // 返回指定页
      let params = this.$route.params
      params.backAppointPage = 1
      if (this.$route.query.resouce != 1) {
        // 非请领单跳转打开的请领出库的界面
        this.$route.params.pageIndex = 1
      }
      this.$router.push({
        name: "DeptInStock", // module里的code
        params: params
      });
    },
    // 合并单元格
    getSpanArr (data) {
      this.spanArr = []
      if (!data) {
        this.$store.dispatch('SetLoading',false)
        return
      }
      // data就是我们从后台拿到的数据
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].rfid === data[i - 1].rfid) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
        // console.log(this.spanArr);
      }
    },
    billingLogoChange(){
      this.getProductList('')
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
<style >
.productBox{
  position: relative;
}
.noCharge{
  position: absolute;
  right: 10px;
  top:3px;
 
}
.noCharge .el-checkbox__label {
 font-size: 12px;
}
.promptBox .el-message-box__message p {
  white-space: pre-wrap;
}
</style>